/** Erro do envelope da API (00 §16): a UI sempre mostra mensagem e código do servidor (07 §10). */
export class ErroApi extends Error {
  constructor(
    public readonly status: number,
    public readonly codigo: string,
    mensagem: string,
    public readonly campos: Record<string, string> | null = null,
    public readonly traceId?: string,
  ) {
    super(mensagem);
    this.name = 'ErroApi';
  }

  get semConexao() {
    return this.status === 0;
  }
}

export function mensagemDe(e: unknown): { texto: string; codigo?: string } {
  if (e instanceof ErroApi) return { texto: e.message, codigo: e.traceId ? `${e.codigo} · ${e.traceId.slice(0, 12)}` : e.codigo };
  if (e instanceof Error) return { texto: e.message };
  return { texto: 'Falha inesperada' };
}
